import React from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import teacherActions from '../../state/teacher/actions'
import cx from 'classnames'

export default function ClassProgressViewType(props) {
  const {isDisabled, isLoading} = props;

  const selectedClassProgressViewType = useSelector(state => state.reports.teacher.classProgressViewType);
  const dispatch = useDispatch();

  const {t} = useTranslation("reports_sidebar");

  const toggleClassProgressViewType = (viewType) => {
    dispatch(teacherActions.setState({classProgressViewType: viewType}));
  }

  const radioClass = cx({
    "reportsRadioButton": true,
    "is-disabled": isDisabled,
    "is-loading": isLoading
  })

  return (
    <div className="reportsSubselection">
      <div className="reportsAdditionalSelectionTitle"> {t("view_type")} </div>
      <div className="reportsRadioButtonSet d-flex flex-column gap-3">
        <div className={radioClass}>
          <input
            id="by-window_radio_btn"
            type="radio"
            onChange={() => toggleClassProgressViewType(CLASSPROGRESS_VIEW_TYPES.BY_WINDOW)}
            checked={selectedClassProgressViewType === CLASSPROGRESS_VIEW_TYPES.BY_WINDOW}
            disabled={isDisabled} />
          <label htmlFor="by-window_radio_btn">{t("by_window")}</label>
          <div className="check"></div>
        </div>
        <div className={radioClass} >
          <input
            id="by-month_radio_btn"
            type="radio"
            onChange={() => toggleClassProgressViewType(CLASSPROGRESS_VIEW_TYPES.BY_MONTH)}
            checked={selectedClassProgressViewType === CLASSPROGRESS_VIEW_TYPES.BY_MONTH}
            disabled={isDisabled} />
          <label htmlFor="by-month_radio_btn">{t("by_month")}</label>
          <div className="check"></div>
        </div>
      </div>
    </div>
  )
}

export const CLASSPROGRESS_VIEW_TYPES = {
  BY_WINDOW: "byWindow",
  BY_MONTH: "byMonth",
} 